import { useSelector } from 'react-redux';

/**
 * Returns permission helpers derived from the current user's pagePermission.
 * pagePermission === 2 means the user has full edit rights.
 */
export const usePermission = () => {
  const permission = useSelector((state: any) => state.auth.pagePermission);
  return {
    permission,
    isEditable: permission === 2,
  };
};

export default usePermission;
